import { Instagram, Mail, Phone } from 'lucide-react';
import { Link } from 'react-router-dom';
import { CONTACTS } from '../config/contacts';

const Footer = () => {
  return (
    <footer className="bg-[#121212] border-t border-white/5 mt-32" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          {/* Brand */}
          <div data-editor-key="identity.tagline">
            <h3 className="text-2xl font-bold tracking-tight mb-4">Daniel Aron</h3>
            <p className="text-[#A3A3A3] leading-relaxed">
              Nutricionista & Personal Trainer especializado em transformação corporal baseada em ciência.
            </p>
          </div>

          {/* Google Maps */}
          <div>
            <h4 className="text-sm font-bold tracking-[0.2em] uppercase text-[#A3A3A3] mb-4">
              Localização
            </h4>
            <div className="w-full h-40 overflow-hidden rounded-sm border border-white/10">
              <iframe
                title="Localização Daniel Aron"
                src="https://www.google.com/maps?q=Av+Jo%C3%A3o+Cabral+de+Mello+Neto+850+Barra+da+Tijuca+Rio+de+Janeiro+RJ+22775-057&output=embed"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              />
            </div>
            <p className="text-[#A3A3A3] text-xs mt-2">
              Av. João Cabral de Mello Neto, 850 — Torre North, 10º Andar · Barra da Tijuca, Rio de Janeiro/RJ
            </p>
          </div>

          {/* Contact */}
          <div data-editor-key="contact">
            <h4 className="text-sm font-bold tracking-[0.2em] uppercase text-[#A3A3A3] mb-4">
              Contato
            </h4>
            <div className="flex flex-col gap-4">
              <a
                href={CONTACTS.whatsappUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-3 text-[#A3A3A3] hover:text-white transition-colors"
                data-testid="footer-whatsapp"
              >
                <Phone size={18} />
                <span>{CONTACTS.phoneDisplay}</span>
              </a>
              <a
                href={`mailto:${CONTACTS.email}`}
                className="flex items-center gap-3 text-[#A3A3A3] hover:text-white transition-colors"
                data-testid="footer-email"
              >
                <Mail size={18} />
                <span>{CONTACTS.email}</span>
              </a>
              <a
                href={CONTACTS.instagram}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-3 text-[#A3A3A3] hover:text-white transition-colors"
                data-testid="footer-instagram"
              >
                <Instagram size={18} />
                <span>{CONTACTS.instagramHandle}</span>
              </a>
            </div>
          </div>
        </div>

        <div data-editor-key="contact.copyright" className="border-t border-white/5 mt-12 pt-8 text-center text-[#A3A3A3] text-sm">
          <p>© 2025 Daniel Aron. Todos os direitos reservados.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
